export default "ALTER TABLE `provider` ADD `deny_data_collection` integer DEFAULT true NOT NULL;"